window.addEventListener("turbolinks:load", () => {
  
});